<template>
  <v-container v-if="message" class="text-center">
    <v-card class="pt-5" style="min-height: 300px;">
      <h2 class="mt-5">{{ message }}</h2>
      <h3 class="mt-5">
        <v-btn to="/">
          перейти на главную
        </v-btn>
      </h3>
    </v-card>
  </v-container>
</template>
  
<script>
import {mapActions} from "vuex";

export default {
  data() {
    return {
      message: null,
    }
  },

  methods: {
    ...mapActions({
      sendConfirm: 'user/sendConfirm',
    }),
  },

  async mounted() {
    this.message = await this.sendConfirm({
      token: this.$route.query.token,
      type: this.$route.query.type,
    });
  },
}
</script>

<style scoped>

</style>
